import React from "react";

export default function Button({ type, label, onClick, ...rest }) {
  return (
    <button type={type} className="btn btn-info btn-lg" onClick={onClick} {...rest}>
      {label}
    </button>
  );
}
